import {
  StyledAvatarBasic,
  StyledLoaderPill,
  StyledLoaderPillContainer,
  StyledLoaderRow,
} from './LoaderRow.styled'

interface LoadingRowProps {
  colOneWidth: number
  colTwoWidth: number
  colThreeWidth: number
}

export const LoadingRow = ({
  colOneWidth,
  colTwoWidth,
  colThreeWidth,
}: LoadingRowProps) => (
  <StyledLoaderRow>
    <StyledAvatarBasic />
    <StyledLoaderPillContainer>
      <StyledLoaderPill width={`${colOneWidth}px`} />
    </StyledLoaderPillContainer>
    <StyledLoaderPillContainer small>
      <StyledLoaderPill width={`${colTwoWidth}px`} />
    </StyledLoaderPillContainer>
    <StyledLoaderPillContainer small align="right">
      <StyledLoaderPill width={`${colThreeWidth}px`} />
    </StyledLoaderPillContainer>
  </StyledLoaderRow>
)
